import * as React from 'react';
import { injectIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { VerificationService, ErrorId, FormFooterComponent, StudentPersonalInfoViewModel, SuccessResponse } from '@sheerid/jslib';

interface StepErrorProps {
    verificationService: VerificationService;
    errorId?: ErrorId;
    intl?: any;
}

const StepError = ({ verificationService, errorId, intl }: StepErrorProps) => {
    const urlParams = new URLSearchParams(window.location.search);
    const programCodeQS = urlParams.get('programCode') || '';

    const personalInfo = verificationService.previousViewModel as StudentPersonalInfoViewModel;
    const verificationId = (verificationService.verificationResponse as SuccessResponse).verificationId || '';
    const programCode = (personalInfo && personalInfo.metadata && personalInfo.metadata.programCode ? personalInfo.metadata.programCode : programCodeQS);

    return (
        <div id="sid-step-error" className="sid-l-container">
            <div className="sid-header sid-l-horz-center">
                <div className="sid-l-horz-center">
                    <img
                        className="sid-l-lead-image"
                        alt="design element"
                        src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-exclamation.svg"
                    />
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="error" defaultMessage="Error" />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-space-top-md">
                    <div className="sid-error-msg sid-l-horz-center">
                        <FormattedMessage id={`errorId.DEFAULT`} defaultMessage="{tryAgain}"
                        values={{tryAgain :
                            <a
                                onClick={ () => verificationService.fetchNewVerificationRequest(verificationService.programId, verificationService.previousViewModel) }
                                onKeyPress={ () => verificationService.fetchNewVerificationRequest(verificationService.programId, verificationService.previousViewModel) }
                            >
                                <FormattedHTMLMessage id="step.error.tryAgain" defaultMessage="try again" />
                            </a>
                        }} />
                    </div>

                    <div className="sid-submit sid-l-space-top-lg sid-l-half-width sid-l-horz-center">
                        <a href={`https://care.siriusxm.com/sirpromoplanselection_view.action?verificationId=${verificationId}&programCode=${programCode}`} target="_parent" className="sid-btn sid-btn--dark">
                            <FormattedHTMLMessage id="step.error.redirectButtonText" defaultMessage="Continue" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-xl sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>
        </div>
    );
};

export const StepErrorComponent = injectIntl(StepError);
